export default __webpack_public_path__ + "static/media/pantry2-before2-1920w.f8300c88.avif";